import React, { useEffect, forwardRef, useState } from 'react'
import { Dialog, Slide } from '@mui/material'
import { TransitionProps } from '@mui/material/transitions'
import { fireReactGAEvent } from '../Questions/utils'
import FromlessInterstitialContent from './FromlessInterstitialContent'
import { fonts } from '@zuto/theme/src/mui/Typography'

const getDialogStyles = (isPreapproved: boolean) => ({
  padding: 0,
  textAlign: 'center',
  backgroundColor: '#fff',
  opacity: 1,
  boxShadow: 0,
  zIndex: '99999999999',
  minHeight: '100vh',
  overflowX: 'hidden',
  '.interstitial-header svg': {
    position: 'relative',
    transform: 'scale(0.90)'
  },
  '.MuiDialog-container': {
    display: 'block',
    height: 'auto',
    minHeight: '100%',
    overflowY: 'auto',
    padding: 0
  },
  '.MuiPaper-root': {
    margin: '0 auto',
    width: '100%',
    padding: '0',
    boxShadow: 0,
    overflow: 'hidden',
    backgroundColor: 'transparent'
  },
  '& .MuiList-root': {
    paddingTop: isPreapproved ? '16px' : 0,
    maxWidth: '300px',
    svg: {
      paddingRight: '10px !important' /* Added important, otherwise would have to pass extra props to the shared component just for this one style */
    },
    li: {
      paddingLeft: 0,
      '& p': {
        fontFamily: fonts.regular
      }
    }
  },
  '.MuiDialogContent-root': {
    maxWidth: '408px',
    width: '100%',
    margin: 'auto',
    overflow: 'hidden',
    padding: '24px',
    boxSizing: 'border-box'
  }
})

const intEvent = (experiment: string, requiredDetails?: boolean, open?: boolean) => {
  const startedOrEnded = open ? 'Interstitial Started' : 'Interstitial Ended'
  fireReactGAEvent({
    category: 'Application Form',
    action: !requiredDetails ? 'FormlessInterstitial Loaded' : startedOrEnded,
    label: experiment
  })
}

const Transition = forwardRef((
  props: TransitionProps & { children: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) => <Slide unmountOnExit direction="right" ref={ref} {...props} />)

export type InterstitialProps = {
  source: string
  experimentName: string
  isPreapproved: boolean,
  requiredDetailsV1?: boolean
}

const FormlessInterstitialWrapper = ({ source, experimentName, isPreapproved, requiredDetailsV1 }: InterstitialProps): JSX.Element => {
  const [open, setOpen] = useState(true)

  useEffect(() => {
    if (requiredDetailsV1 && open) {
      setTimeout(() => {
        setOpen(false)
        intEvent(experimentName, requiredDetailsV1, false)
      }, 4000)
    }
  }, [open])

  useEffect(() => {
    intEvent(experimentName, requiredDetailsV1, true)
    requiredDetailsV1 && setOpen(true)
  }, [])

  return (
    <Dialog
      open={requiredDetailsV1 ? open : true}
      data-testid={`${source}-interstitial`}
      TransitionComponent={Transition}
      keepMounted={false}
      aria-describedby="Transferring you to Zuto, our car finance partner"
      sx={getDialogStyles(isPreapproved)}
      slotProps={{ backdrop: { style: { backgroundColor: 'rgba(255,255,255,0)' } } }}
      fullWidth
    >
      <FromlessInterstitialContent source={source} isPreapproved={isPreapproved} isRequiredDetailsV1={requiredDetailsV1} />
    </Dialog>
  )
}

export default FormlessInterstitialWrapper
